<template>
	<div class="inner-page treatment-plan">

		<div v-if="thisCase.status != 'archive'">

			<AppHead title="Treatment Plan Approval" />

		

			<PageHeader 
				title="Treatment Plan Approval"
				desc="Please approve or reject your treatment plan"
				:hasButton="false"
				:showHelper="true"
				helpTitle="Approving your treatment plan"
				helpDesc="Your next step is to approve or reject your treatment plan that you have received. Please ensure you do this before the deadline otherwise this may lead to delays."
				/>

			<CaseProgressBar 
				:step="thisCase.progress_stage" 
				:thisCase="thisCase"
				:pageStep="3"
				/>


			<template v-if="treatmentPlans.length > 0">
				<Subtitle
					title="Treatment Plan"
					/>
				<div class="file-list" v-if="treatmentPlans.length > 0">

					<ButtonDownload
						v-for="(plan, index) in treatmentPlans"
						:key="index"
						:file="plan"
						class="file"
						icon="file-alt"
						/>
				</div>

				<Subtitle
					title="Notes"
					v-if="thisCase.treatment_plan_notes"
					/>
				<div class="notes-box white-box" v-if="thisCase.treatment_plan_notes">
					{{ thisCase.treatment_plan_notes }}
				</div>
				

				<div 
					v-if="(thisCase.treatment_plan_approved == null || (thisCase.treatment_plan_approved == 'rejected' && treatmentPlans.length > 1)) && treatmentPlans[0].is_available"
					class="treatment-plan-form"
					>
					
					<Subtitle
						title="Approve plan"
						subtext="Please approve or ask for changes to your treatment plan"
						/>

					
					<div class="button-box">
						<Button
							label="Approve"
							color="green"
							size="large"
							icon="check" 
							@click="approveTreatmentPlan"
							/>
						<Button
							label="Changes Required"
							color="yellow"
							size="large"
							icon="times"
							push="left"
							@click="rejectTreatmentPlan"
							/>
						<Button
							label="Back"
							color="white"
							size="large"
							icon="chevron-double-left"
							push="left"
							:buttonRoute="`/cases/${thisCase.hashid}`"
							/>
					</div>

					<Subtitle
						title=""
						subtext="If changes are required, please let us know what changes you require by using the chat function or by email."
						/>

				</div>

				<div 
					v-if="thisCase.treatment_plan_approved == 'approved'"
					class="treatment-plan-approved white-box"
					>
					<span v-if="thisCase.treatment_plan_approved_by">
						<strong>{{ thisCase.treatment_plan_approved_by.name }}({{ thisCase.treatment_plan_approved_by.email }})</strong> has approved the treatment plan <strong>{{ thisCase.treatment_plan_approved_file.file_name }}</strong> on <strong>{{ formatDate(thisCase.treatment_plan_approval_date) }}</strong>
					</span>

					<span v-else>
						The treatment plan was approved
					</span>
				</div>

				<template v-if="oldTreatmentPlans.length > 0">
					<Subtitle
						title="Older Treatment Plans"
						/>
					<div class="file-list" v-if="oldTreatmentPlans.length > 0">

						<ButtonDownload
							v-for="(plan, index) in oldTreatmentPlans"
							:key="index"
							:file="plan"
							class="file"
							icon="file-alt"
							/>
					</div>
				</template>

			</template>
			<div v-else>
				<Placeholder
					message="No treatment plan has been uploaded yet. Please check back later."
					/>
			</div>


			<template v-if="ifus.length > 0">
				<Subtitle
					title="Instructions for use"
					/>
				<div class="file-list" v-if="ifus.length > 0">

					<ButtonDownload
						v-for="(ifu, index) in ifus"
						:key="index"
						:file="ifu"
						class="file"
						icon="file-alt"
						emptyText="Instructions for use processing"
						/>
				</div>
			</template>

		</div>
		<Placeholder
			v-else
			message="This case has been archived. You can no longer edit it."
			:withBackButton="true"
			/>

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import ButtonDownload from "@/Components/ButtonDownload"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import Subtitle from "@/Components/Subtitle"
import FileBox from "@/Components/Cases/FileBox"
import Placeholder from "@/Components/Placeholder"

import moment from 'moment'

export default {
	props: [
		'thisCase',
		'treatmentPlans',
		'oldTreatmentPlans',
		'ifus'
	],
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		ButtonDownload,
		CaseProgressBar,
		Subtitle,
		FileBox,
		Placeholder
	},
	layout: AppLayout,
	data: () => {
		return {
			
		}
	},
	mounted(){
		// console.log('ifus', this.ifus)
		// console.log('thiscase', this.thisCase)
	},
	methods: {
		approveTreatmentPlan(){
			this.$inertia.post(`/cases/${this.thisCase.hashid}/review-treatment-plan`, { 
				treatment_plan_approved: 'approved',
				treatment_plan_approved_file: this.treatmentPlans[0].id,
				treatment_plan_approved_by: this.$page.props.user.id
			})
		},
		rejectTreatmentPlan(){
			if(confirm('Please let us know what changes you require by using the chat function or by email')){
				this.$inertia.post(`/cases/${this.thisCase.hashid}/review-treatment-plan`, { treatment_plan_approved: 'rejected' })
			}
		},
		formatDate(inputDate) {
			if(inputDate != null){
				return moment(inputDate).format('Do MMMM YYYY')
			}
		},
	},
};

</script>

<style scoped lang="sass">

.treatment-plan
	.white-box
		background-color: #fff
		padding: 20px
		margin-bottom: 30px
		border-radius: 8px
		box-shadow: 0 0 10px rgba(0,0,0,0.1)

	.treatment-plan-form
		padding-top: 30px
					
	.button-box
		display: flex

	.notes
		font-family: 'Roboto', sans-serif
		font-size: 16px
		line-height: 1.3
		color: #222
		padding: 20px
		border-radius: 3px
		background-color: rgba(#000, 0.02)

	.file-list
		display: flex
		flex-direction: column

		.file
			margin-bottom: 20px

</style>